import { GET } from './authentication-api'
import { environments, getBaseUrls } from '../../common/environment-configs'

const AUTHENTICATION_PATH = '/credentials'
const CREDENTIALS_SEPARATOR = ':'
const CREDENTIALS_KEY = 'data'

const checkCredentialsCall = async (baseUrl) => {
  if (baseUrl === undefined || baseUrl == null) {
    return false
  }
  return GET(baseUrl + AUTHENTICATION_PATH)
}

export const areCredentialsValid = () => {
  return checkCredentialsCall(getBaseUrls(environments.PRE).Oysho)
}

export const getUserCredentials = () => {
  const data = atob(localStorage.getItem(CREDENTIALS_KEY)).split(CREDENTIALS_SEPARATOR)
  if (data.length > 1) {
    return {
      username: data[0],
      password: data[1]
    }
  }
  return {
    username: '',
    password: ''
  }
}

export const setUserCredentials = (username, password) => {
  localStorage.setItem(CREDENTIALS_KEY, btoa(username + CREDENTIALS_SEPARATOR + password))
}

export default areCredentialsValid
